import React from 'react';

const ShipyardCommentsTable = () => {
  return (
    <div className="bg-white text-black p-4">
      <div className="flex mb-2">
        <span className="font-bold mr-2">2.</span>
        <h2 className="font-bold text-black underline">Shipyard Comments</h2>
      </div>
      
      <table className="w-full border-collapse">
        <thead>
          <tr>
            <th className="border border-black p-2 text-center w-16">Ser</th>
            <th className="border border-black p-2 text-center">Activity</th>
            <th className="border border-black p-2 text-center text-black">Shipyard comments</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="border border-black p-2"></td>
            <td className="border border-black p-2">Impact Of Covid-19 and Force Majeure</td>
            <td className="border border-black p-2"></td>
          </tr>
          <tr>
            <td className="border border-black p-2"></td>
            <td className="border border-black p-2">Subcontracting/ Outsourcing</td>
            <td className="border border-black p-2"></td>
          </tr>
          <tr>
            <td className="border border-black p-2"></td>
            <td className="border border-black p-2">Inputs required for achieving Physical Progress</td>
            <td className="border border-black p-2"></td>
          </tr>
          <tr>
            <td className="border border-black p-2"></td>
            <td className="border border-black p-2">Production Drawings</td>
            <td className="border border-black p-2">Production drawing Summary table</td>
          </tr>
          <tr>
            <td className="border border-black p-2"></td>
            <td className="border border-black p-2">Detailed Design (For All Yards)</td>
            <td className="border border-black p-2"></td>
          </tr>
          <tr>
            <td className="border border-black p-2"></td>
            <td className="border border-black p-2">Approvals</td>
            <td className="border border-black p-2">
              <span className="text-green-500">is placed at </span>
              <span className="font-bold">Enclosure-2</span>
            </td>
          </tr>
          <tr>
            <td className="border border-black p-2"></td>
            <td className="border border-black p-2">Development of 3DCAD Model and LOI/approval of CLOs</td>
            <td className="border border-black p-2">
              <div>CLO status Summary <span className="font-bold">Table</span></div>
              <div className="mt-1">
                <table className="w-full border-collapse border border-black">
                  <tbody>
                    <tr>
                      <td className="border border-black p-1 h-8"></td>
                      <td className="border border-black p-1 h-8"></td>
                      <td className="border border-black p-1 h-8"></td>
                    </tr>
                    <tr>
                      <td className="border border-black p-1 h-8"></td>
                      <td className="border border-black p-1 h-8"></td>
                      <td className="border border-black p-1 h-8"></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
          <tr>
            <td className="border border-black p-2"></td>
            <td className="border border-black p-2">Procurement</td>
            <td className="border border-black p-2"></td>
          </tr>
          <tr>
            <td className="border border-black p-2"></td>
            <td className="border border-black p-2">MDL procured project equipment</td>
            <td className="border border-black p-2">
              <div>
                <span className="text-green-500">is placed at </span>
                <span className="font-bold">Enclosure-4</span>
              </div>
              <div className="mt-2">
                <span className="text-green-500">is placed at </span>
                <span className="font-bold">Enclosure-5</span>
              </div>
            </td>
          </tr>
          <tr>
            <td className="border border-black p-2"></td>
            <td className="border border-black p-2">BFE</td>
            <td className="border border-black p-2">
              <span className="text-green-500">is placed at </span>
              <span className="font-bold">Enclosure-3</span>
            </td>
          </tr>
          <tr>
            <td className="border border-black p-2"></td>
            <td className="border border-black p-2">Yard Material</td>
            <td className="border border-black p-2">
              <div>
                <span className="font-bold">Procurement of Steel </span>
                <span>at </span>
                <span className="font-bold">Enclosure-6</span>
                <span>.</span>
              </div>
              <div className="mt-2">
                <span className="font-bold">Procurement of Pipes and Pipe Fittings</span>
              </div>
            </td>
          </tr>
          <tr>
            <td className="border border-black p-2"></td>
            <td className="border border-black p-2">Other Major Updates</td>
            <td className="border border-black p-2"></td>
          </tr>
          <tr>
            <td className="border border-black p-2"></td>
            <td className="border border-black p-2">Doors and Hatches</td>
            <td className="border border-black p-2">
              <span className="text-green-500">Summary Table for all yards</span>
            </td>
          </tr>
          <tr>
            <td className="border border-black p-2"></td>
            <td className="border border-black p-2">Pumps Status (Total: 55 Nos per ship)</td>
            <td className="border border-black p-2">
              <span className="text-green-500">Summary Table</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default ShipyardCommentsTable;